module.exports = __webpack_public_path__ + "static/media/flower_bottom@2x.f2773201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/flower_bottom@2x.png
// module id = 385
// module chunks = 0